module.exports = __webpack_public_path__ + "static/divyaRani-49a237a08d538bbe9e9d1c854c1b058d.jpg";